import Lenis from "lenis"
import "lenis/dist/lenis.css"
import type { ReactNode } from "react"
import { useEffect } from "react"
import { CookieConsent } from "@/components/marketing/cookie-consent"
import { MarketingAssistant } from "@/components/marketing/marketing-assistant"
import { MarketingFooter } from "@/components/marketing/marketing-footer"
import { MarketingNav } from "@/components/marketing/marketing-nav"

export function MarketingLayout({ children }: { children: ReactNode }) {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return
    }

    const smoothScroll = new Lenis({
      anchors: { offset: -96 },
      autoRaf: true,
      autoToggle: true,
      duration: 0.8,
      smoothWheel: true,
      stopInertiaOnNavigate: true,
      wheelMultiplier: 0.92,
    })

    return () => smoothScroll.destroy()
  }, [])

  return (
    <div className="resolto-texly-page min-h-screen bg-background text-foreground">
      <a href="#main-content" className="marketing-skip-link">
        Skip to content
      </a>
      <MarketingNav />
      <main id="main-content" tabIndex={-1}>
        {children}
      </main>
      <MarketingFooter />
      <CookieConsent />
      <MarketingAssistant />
    </div>
  )
}
